import React, { Fragment } from "react";
import { D3LinePlot } from "cd-eft/components/common/D3LinePlot/D3LinePlot";
import { observer } from "mobx-react";
import { formatRoundS } from "cd-eft/utils/mathUtilities";

interface IStatusDischargeProps {
    targetDivId: string;
    windowOptions: any;
    plotData: any;// object with entries that have values as 2d arrays
    forReport: boolean;
    splitTableData?: any;// if using in a report, this is the data array split apart into chunks
}

export const StageDischargeGraph = observer((props: IStatusDischargeProps) => {
    const { targetDivId, windowOptions, plotData, forReport } = props;
    return (
        <div className={`row formula-graph-container${forReport ? '-report' : ''}`}>
            <div className={`col-3 formula-graph-table${forReport ? '-report' : ''}`}>
                <table className='usa-table usa-table--stacked usa-table--striped table-mobile' tabIndex={0}>
                    <thead>
                        <tr>
                            <th scope="col" id="stage-header">Stage (ft)</th>
                            <th scope="col" id="flow-header">Discharge (cfs)</th>
                        </tr>
                    </thead>
                    <tbody>
                        {plotData.stageDischargeData.map(
                            (row, index) => (
                                <tr>
                                    <td headers="stage-header" key={`stage-data-${index}`}>{formatRoundS((+row[0]), 2)}</td>
                                    <td headers="flow-header" key={`flow-data-${index}`}>{formatRoundS((+row[1]), 2)}</td>
                                </tr>
                            )
                        )}
                    </tbody>
                </table>
            </div>
            <div className={`col-9 formula-graph-line${forReport ? '-report' : ''}`}>
                <D3LinePlot targetDivID={targetDivId} windowOptions={windowOptions} plotData={plotData} forReport={forReport} />
            </div>
        </div>
    )
})

export const StageDischargeGraphReport = observer((props: IStatusDischargeProps) => {
    const { targetDivId, windowOptions, plotData, forReport, splitTableData } = props;
    return (
        <Fragment>
            {splitTableData.map((tableSet, index) => (
                <div className="formula-report-graph">
                    <div className={`row formula-graph-container${forReport ? '-report' : ''}`}>
                        <div className={`col-3 formula-graph-table${forReport ? '-report' : ''}`}>
                            <table className='usa-table usa-table--stacked usa-table--striped table-mobile'>
                                <thead>
                                    <tr>
                                        <th>Stage (ft)</th>
                                        <th>Discharge (cfs)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {tableSet.map(
                                        (row) => (
                                            <tr>
                                                <td>{formatRoundS((+row[0]), 2)}</td>
                                                <td>{formatRoundS((+row[1]), 2)}</td>
                                            </tr>
                                        )
                                    )}
                                </tbody>
                            </table>
                        </div>
                        <div className={`col-9 formula-graph-line${forReport ? '-report' : ''}-${index}`}>
                            <D3LinePlot targetDivID={targetDivId + `-${index}`} windowOptions={windowOptions} plotData={plotData} forReport={forReport} />
                        </div>
                    </div>
                </div>
            ))}
        </Fragment>
    )
})